import React from 'react'
import PropTypes from 'prop-types';
// import withState from 'recompose/withState'
import TextField from 'material-ui/TextField'
import { ChromePicker } from 'react-color'

const PickerDialog = ({
  value,
  onClick,
  onChange
}) => (
  <div style={{ position: 'absolute', zIndex: '22', left:'50%', transform:'translateX(-50%)', top:'25px' }}>
    <div
      style={{ position: 'fixed', top: '0px', right: '0px', bottom: '0px', left: '0px' }}
      onClick={onClick}
    />
    <ChromePicker
      color={value}
      onChange={onChange}
    />
  </div>
)

PickerDialog.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  onClick: PropTypes.func
}

class ColorPicker extends React.Component {
	constructor(props) {
	  super(props);
	
	  this.state = {
	  	showPicker: false,
	  	value: this.props.value ? this.props.value : this.props.defaultValue
	  };
	}

	handleCloseColorPicker = () => {
		this.setState({showPicker: false});
	}

	converters(convert = 'rgba_hex') {
		const converters = {
		  rgba: c => `rgba(${c.rgb.r}, ${c.rgb.g}, ${c.rgb.b}, ${c.rgb.a})`,
		  rgb: c => `rgb(${c.rgb.r}, ${c.rgb.g}, ${c.rgb.b})`,
		  hex: c => c.hex,

		  rgba_rgb: c => c.rgb.a === 1 ? converters.rgb(c) : converters.rgba(c),
		  rgba_hex: c => c.rgb.a === 1 ? converters.hex(c) : converters.rgba(c)
		}

		return converters[convert];
	}

	componentWillReceiveProps(nextProps) {
		if(this.props.isColorPickersVisible !== nextProps.isColorPickersVisible &&
			 this.state.showPicker === true && this.props.indexActiveColorPicker !== this.props.indexColorPicker
		  ) {
			this.setState({showPicker: false})
		}

	  if (this.props.value !== nextProps.value) {
	  	this.setState({ value: nextProps.value})
	  }
	}

	render() {
		const { name,id, hintText, floatingLabelText } = this.props;

		return (
		  <div className="picker-square-container">
		  	<style>
		  		{
		  			`.picker-square {
								width: 35px;
								height: 20px;
								border: 1px solid gray;
		  			}`
		  	}
		  	</style>

		  	{this.props.isSquareVisible &&
		  		<div
			  		className={`picker-square ${this.props.squareClass}`}
			  		onClick={() => this.setState({ showPicker: !this.state.showPicker })}
			  		style={{backgroundColor: this.state.value}}
		  		>
		  		</div>
		  	}
		    <TextField
		    	style={{ display: this.props.isSquareVisible ? 'none' : 'inherit'}}
		    	className={this.props.textFieldClass}
		      name={name}
		      id={id}
		      hintText={hintText}
		      value={this.state.value}
		      floatingLabelText={floatingLabelText}
		      inputStyle={{ color: this.state.value }}
		      onClick={() => this.setState({showPicker: true})}
		      onChange={e => {
		        this.setState({ value: e.target.value })
		        this.props.onChange(e.target.value)
		      }}
		    />
		    {this.state.showPicker && (
		      <PickerDialog
		        value={this.state.value}
		        onClick={() => {
		          this.setState({showPicker: false});
		          this.props.onChange(this.state.value)
		        }}
		        onChange={c => {
		          const newValue = this.converters()(c)
		          this.setState({ value: newValue })
		          this.props.onChange(newValue)
		        }}
		      />
		    )}
		  </div>
		);
	}
}

ColorPicker.propTypes = {
  value: PropTypes.string,
  defaultValue: PropTypes.string,
  onChange: PropTypes.func,
  isSquareVisible: PropTypes.bool,
  squareClass: PropTypes.string,
	textFieldClass: PropTypes.string,
	isColorPickerVisible: PropTypes.bool
}

export default ColorPicker;



// WEBPACK FOOTER //
// ./src/components/colorPicker/ColorPicker.js